import {
  MaskByFormatParams,
  MaskingHandlerResult,
  MaskingHandlers,
  PhoneNumberMaskParams,
  TelegramUsernameMaskParams,
} from '../types/common/common-types';

const maskingHandlers: MaskingHandlers = {
  phoneNumberMask<InputType>({ value, onlyRu = false }: PhoneNumberMaskParams<InputType>) {
    let formattedValue = (value as string).replace(/[^\d+#]/g, '');
    const [mainNumber, ext] = formattedValue.split('#');

    let mainFormattedValue = mainNumber.replace(/[^\d+]/g, '');

    const isRussianNumber = formattedValue.startsWith('+7') || formattedValue.startsWith('8');

    if (!formattedValue) {
      return { updatedValue: '', updatedUnmaskedValue: '' } as MaskingHandlerResult<InputType>;
    }

    if (!formattedValue.startsWith('+') && !formattedValue.startsWith('8')) {
      formattedValue = '+' + formattedValue;
    }

    const maxDigits = 15;
    const digitsOnly = mainFormattedValue.replace(/\D/g, '').slice(0, maxDigits);
    mainFormattedValue = mainFormattedValue.startsWith('+') ? '+' + digitsOnly : digitsOnly;

    let maskedValue = '';
    if (isRussianNumber || onlyRu) {
      const digits = mainFormattedValue.replace(/[^\d+]/g, '');
      const countryCode = digits.startsWith('8') ? '8' : '+7';

      if (digits.length <= countryCode.length) {
        maskedValue = digits;
      } else if (digits.length <= countryCode.length + 3) {
        maskedValue = `${countryCode} ${digits.slice(countryCode.length)}`;
      } else if (digits.length <= countryCode.length + 6) {
        maskedValue = `${countryCode} ${digits.slice(
          countryCode.length,
          countryCode.length + 3,
        )} ${digits.slice(countryCode.length + 3)}`;
      } else if (digits.length <= countryCode.length + 8) {
        maskedValue = `${countryCode} ${digits.slice(
          countryCode.length,
          countryCode.length + 3,
        )} ${digits.slice(countryCode.length + 3, countryCode.length + 6)}-${digits.slice(
          countryCode.length + 6,
        )}`;
      } else {
        maskedValue = `${countryCode} ${digits.slice(
          countryCode.length,
          countryCode.length + 3,
        )} ${digits.slice(countryCode.length + 3, countryCode.length + 6)}-${digits.slice(
          countryCode.length + 6,
          countryCode.length + 8,
        )}-${digits.slice(countryCode.length + 8)}`;
      }
    } else {
      maskedValue = formattedValue;
    }

    if (formattedValue.includes('#')) {
      const maxExt = 8;
      maskedValue += `#${ext.slice(0, maxExt)}`;
      formattedValue = mainNumber + `#${ext.slice(0, maxExt)}`;
    }

    return {
      updatedValue: maskedValue,
      updatedUnmaskedValue: formattedValue,
    } as MaskingHandlerResult<InputType>;
  },
  maskByFormat<InputType>({ value, format }: MaskByFormatParams<InputType>) {
    let maskedValue = '';
    let unmaskedValue = '';
    let formatIndex = 0;
    let digitCount = 0;

    for (let i = 0; i < (value as string).length; i++) {
      if (formatIndex >= format.length) break;

      const currentChar = value[i];
      const currentFormatChar = format[formatIndex];

      if (currentFormatChar === '0') {
        if (/\d/.test(currentChar)) {
          if (format === '00:00') {
            if (formatIndex === 3) {
              if (parseInt(currentChar) > 5) {
                continue;
              }
            }
            if (digitCount === 2 && parseInt(currentChar) > 5) {
              continue;
            }
          }

          maskedValue += currentChar;
          unmaskedValue += currentChar;
          formatIndex++;
          digitCount++;
        }
      } else if (currentFormatChar === 'x') {
        if (/[a-zA-Z]/.test(currentChar)) {
          maskedValue += currentChar;
          unmaskedValue += currentChar;
          formatIndex++;
        }
      } else {
        if (currentChar === currentFormatChar) {
          maskedValue += currentChar;
          unmaskedValue += currentChar;
          formatIndex++;
        } else {
          maskedValue += currentFormatChar;
          unmaskedValue += currentFormatChar;
          formatIndex++;
          i--;
        }
      }
    }

    return {
      updatedValue: maskedValue,
      updatedUnmaskedValue: unmaskedValue,
    } as MaskingHandlerResult<InputType>;
  },
  telegramUsernameMask<InputType>({ value }: TelegramUsernameMaskParams<InputType>) {
    const filteredValue = (value as string).replace(/@/g, '');

    return {
      updatedValue: filteredValue,
      updatedUnmaskedValue: filteredValue,
    } as MaskingHandlerResult<InputType>;
  },
};

export { maskingHandlers };
